import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { EventEntryStateDescriptionEnum } from '../../eventDetails/EventDetails.enum';
import * as Styled from '../../eventDetails/EventDetails.styles';

import { InneEventDetailsProps } from './InneEventDetails.types';

export const InneEventDetails = ({ selectedEvent }: InneEventDetailsProps) => {
  const { formatMessage } = useLocale();
  const ownerFullName = selectedEvent.posiadacz
    ? `${selectedEvent.posiadacz.nazwisko || ''} ${selectedEvent.posiadacz.imie || ''}`.trim()
    : '';

  return (
    <>
      {selectedEvent.nazwaCzytnika && (
        <Styled.DetailsItemWrapper>
          <Styled.DetailName>{formatMessage({ id: AppMessages['events.other.details.readerName'] })}</Styled.DetailName>
          <Styled.DetailText> {selectedEvent.nazwaCzytnika} </Styled.DetailText>
        </Styled.DetailsItemWrapper>
      )}

      <Styled.DetailsItemWrapper>
        <Styled.DetailName>{formatMessage({ id: AppMessages['events.other.details.serverName'] })}</Styled.DetailName>
        <Styled.DetailText> {selectedEvent.nazwaSerwera} </Styled.DetailText>
      </Styled.DetailsItemWrapper>

      {ownerFullName && (
        <Styled.DetailsItemWrapper>
          <Styled.DetailName>{formatMessage({ id: AppMessages['event.details.owner'] })}</Styled.DetailName>
          <Styled.DetailText>{ownerFullName}</Styled.DetailText>
        </Styled.DetailsItemWrapper>
      )}

      <Styled.DetailsItemWrapper>
        <Styled.DetailName>{formatMessage({ id: AppMessages['event.details.entryState'] })}</Styled.DetailName>
        <Styled.DetailTextBold>
          {formatMessage({ id: AppMessages[EventEntryStateDescriptionEnum[selectedEvent.stanWejscia]] })}
        </Styled.DetailTextBold>
      </Styled.DetailsItemWrapper>

      <Styled.DetailsItemWrapper>
        <Styled.DetailName>{formatMessage({ id: AppMessages['events.other.details.zone'] })}</Styled.DetailName>
        <Styled.DetailTextBold> {selectedEvent.strefa} </Styled.DetailTextBold>
      </Styled.DetailsItemWrapper>
    </>
  );
};
